import { IOSMResponse } from "@eventr/common";
import { ColoursObj, Icon } from "@eventr/common-storybook";
import { useMemo } from "react";
import { useMapSelector } from "hooks/useMapSelector";
import { CardText } from "./cardText";
import { RowInfo } from "./rowInfo";

interface IRowInfoAddressProps {
  address: IOSMResponse;
}
export const RowInfoAddress = ({ address }: IRowInfoAddressProps) => {
  const addressString = useMemo(() => {
    if (!address) return "";
    const addressStringArray = [
      address.address?.house_number,
      address.address?.road,
      address.address?.city,
      address.address?.country,
      address.address?.postcode,
    ];

    return addressStringArray.filter((item) => item !== undefined && item !== "").join(", ");
  }, [address]);

  const lonLat = useMemo(() => {
    if (!address) return "";

    const addressLon = address?.lon;
    const addressLat = address?.lat;
    if (addressLon && addressLat) {
      return `${addressLat}, ${addressLon}`;
    }
  }, [address]);

  // Prefer display_name if available, otherwise fall back to lon/lat or address string
  const query = address?.display_name ?? (lonLat || addressString || undefined);
  const openMapSelector = useMapSelector(query);

  if (addressString === "") return null;
  return (
    <RowInfo
      start={<Icon name="Location_Pin" bubble bubbleColour={ColoursObj.coreBrights.secondary} />}
      middle={
        <CardText
          onClick={(e) => {
            e.stopPropagation();
            openMapSelector();
          }}
        >
          {addressString}
        </CardText>
      }
    />
  );
};
